var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playlist"},[_c('PlaylistCard',_vm._b({on:{"openContent":_vm.toggleContent}},'PlaylistCard',{
      playlist: _vm.playlist,
      isOpen: _vm.isOpen,
      isSonarPlaylist: _vm.isSonarPlaylist,
    },false)),(_vm.isOpen)?_c('PlaylistContent',{attrs:{"playlistId":_vm.playlist.id,"loading":_vm.isLoading,"isSonarPlaylist":_vm.isSonarPlaylist},on:{"close-content":_vm.toggleContent,"go-to-assessment":_vm.goToAssessmentHandler}}):_vm._e(),(_vm.showMobileAlertModal)?_c('SonarMobileAlert'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }